import { BattleResult, BattleResultType } from '../types/BattleState';

/**
 * サーバー視点の結果をプレイヤー視点に変換する
 * Player2の場合、PLAYER1_WIN ↔ PLAYER2_WIN を反転する
 */
export function adjustResultForPlayer(resultType: BattleResultType, playerNumber: 1 | 2): BattleResultType {
  if (playerNumber !== 2) return resultType;
  if (resultType === BattleResultType.PLAYER1_WIN) return BattleResultType.PLAYER2_WIN;
  if (resultType === BattleResultType.PLAYER2_WIN) return BattleResultType.PLAYER1_WIN;
  return resultType;
}

/**
 * BattleResult をプレイヤー視点に変換して返す
 * resultType のみ変換し、他のフィールドはそのまま引き継ぐ
 */
export function buildPlayerBattleResult(result: BattleResult, playerNumber: 1 | 2): BattleResult {
  return {
    ...result,
    resultType: adjustResultForPlayer(result.resultType, playerNumber),
  };
}
